// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__21CJD","col":"Table_col__2Fz3G","fulfillmentStatus":"Table_fulfillmentStatus__25SQE","emailCol":"Table_emailCol__1BUTf"};